import React from 'react';

/* ===============================
   Components
   =============================== */

export const bullet = '\u00B7'; // Middle dot
export const Bullet = ({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => (
  <>{size == 'sm' ? '·' : size == 'md' ? '•' : '●'}</>
); // Middle dot

